import { loadable } from 'utils';

export const Configurations = loadable(() => import('./Configurations'), {});
export const Offering = loadable(() => import('./Offering'), {});
export const Showcase = loadable(() => import('./Showcase'), {});
